<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-folder-plus"></i> {{title | translate}}</h4>
    <label class="float-right mt-8-custom">
      <a class="mr-2 ml-2" href="javascript:"
         (click)="viewParams()">{{ "BUTTON.VIEW-FORMAT-DOCUMENT" | translate }}</a>
    </label>
  </div>
  <div class="modal-body">
    <app-alert-add-document [message]="message"></app-alert-add-document>
    <form [formGroup]="documentForm">
      <div>
        <div class="row div-custom">
          <div class="col-md-3 font-weight-bold">{{ "TABLE.HEADER.WORKFLOW" | translate }}</div>
          <div class="col-md-3 font-weight-light">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-code-branch"></i>
                </div>
              </div>
              <select id="workflowInput"
                      class="form-control w-100"
                      [attr.disabled]="uploadedDocument ? '' : null"
                      [(ngModel)]="workFlowSelected"
                      (ngModelChange)="reload(typeLoadSelected)"
                      formControlName="workflow">
                <option *ngFor="let workflow of workflows"
                        [ngValue]="workflow">{{workflow.description | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 font-weight-bold">{{ "TABLE.HEADER.SUBJECT" | translate }}</div>
          <div class="col-md-4 font-weight-light">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-keyboard" aria-hidden="true"></i></div>
              </div>
              <input type="text" class="form-control w-100"
                     [attr.disabled]="hasFiles ? '' : null"
                     [(ngModel)]="subject"
                     formControlName="subject"
                     [class.is-invalid]="isInvalidControl('subject')">
            </div>
            <small *ngIf="isInvalidControl('subject')"
                   class="text-danger">
              {{getErrorMessageBy('subject')}}
            </small>
          </div>
        </div>
        <div class="row div-custom">
          <div class="col-md-3 font-weight-bold" *ngIf="isDataSource">{{ "TABLE.HEADER.TEMPLATE" | translate }}</div>
          <div class="col-md-3 font-weight-light" *ngIf="isDataSource">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fas fa-file-export"></i></div>
              </div>
              <select id="template"
                      class="form-control w-100"
                      [attr.disabled]="uploadedDocument ? '' : null"
                      [(ngModel)]="templateSelected"
                      formControlName="template">
                <option *ngFor="let template of templates"
                        [ngValue]="template">{{template.description | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 font-weight-bold" *ngIf="!isDataSource">{{ "TABLE.HEADER.TYPE-LOAD" | translate }}</div>
          <div class="col-md-3 font-weight-light" *ngIf="!isDataSource">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="{{isTypeFile ? 'fa fa-file': 'fa fa-folder'}}"></i></div>
              </div>
              <select class="form-control  w-100"
                      [(ngModel)]="typeLoadSelected"
                      [attr.disabled]="uploadedDocument ? '' : null"
                      formControlName="typeLoad"
                      (ngModelChange)="reload(typeLoadSelected)"
                      id="typeLoad">
                <option [value]=1>{{ "LABEL.FILE" | translate }}</option>
                <option [value]=0>{{ "LABEL.FOLDER" | translate }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 font-weight-bold">{{ "TABLE.HEADER.FILE" | translate }}</div>
          <div class="col-md-4 font-weight-light">
            <div class="col padding-select-file content-file" *ngIf="isTypeFile && !isDataSource">
              <div class="custom-file content-file">
                <input type="file" multiple class="custom-file-input w-100" accept="application/pdf"
                       [attr.disabled]="uploadedDocument || !hasDate2Notify() ? '' : null"
                       id="customFile1" (change)="changeStatus($event)"
                       formControlName="rubricFilename2Show"
                       [class.is-invalid]="isInvalidControl('rubricFilename2Show')">
                <div class="custom-file-label">
                  <label for="customFile1">
                    {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
              <small *ngIf="isInvalidControl('rubricFilename2Show')"
                     class="text-danger">
                {{getErrorMessageBy('rubricFilename2Show')}}
              </small>
            </div>
            <div class="col padding-select-file content-file" *ngIf="!isTypeFile && !isDataSource">
              <div class="custom-file content-file">
                <input type="file" webkitdirectory multiple class="custom-file-input w-100"
                       [attr.disabled]="uploadedDocument || !hasDate2Notify() ? '' : null"
                       id="customFile2" (change)="changeStatus($event)"
                       formControlName="rubricFilename2Show1"
                       [class.is-invalid]="isInvalidControl('rubricFilename2Show1')">
                <div class="custom-file-label">
                  <label for="customFile2">
                    {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
              <small *ngIf="isInvalidControl('rubricFilename2Show1')"
                     class="text-danger">
                {{getErrorMessageBy('rubricFilename2Show1')}}
              </small>
            </div>
            <div class="custom-file content-file" *ngIf="isDataSource">
              <input type="file"
                     class="custom-file-input"
                     accept=".xls, .xlsx"
                     id="customRubricFile2"
                     [attr.disabled]="hasFiles || !hasDate2Notify() || subject === undefined || subject === '' ? '' : null"
                     (change)="changeStatus1($event)"
                     formControlName="rubricFilename2Show2"
                     [class.is-invalid]="isInvalidControl('rubricFilename2Show2')">
              <div class="custom-file-label">
                <label for="customRubricFile2">
                  {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
                </label>
              </div>
              <small *ngIf="isInvalidControl('rubricFilename2Show2')"
                     class="text-danger">
                {{getErrorMessageBy('rubricFilename2Show2')}}
              </small>
            </div>
          </div>
        </div>
        <div class="row div-custom" *ngIf="isScheduledNotify">
          <div class="col-md-3 font-weight-bold">
            <label class="font-weight-bold content">{{ "LABEL.DATE-NOTIFY" | translate }}</label>
          </div>
          <div class="col-md-4 font-weight-light">
            <app-date-time-picker></app-date-time-picker>
          </div>
        </div>
      </div>
      <div *ngIf="!isDataSource && isUploaded">
        <div class="table-responsive">
          <table class="table-sm table-bordered">
            <thead class="thead-dark">
            <tr>
              <th scope="col" class="font-weight-bold" title="#"></th>
              <th scope="col" *ngIf="!isDataSource" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"></th>
              <th scope="col" title="{{ 'TABLE.HEADER.PROGRESS' | translate }}"></th>
              <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
              <th scope="col" title="{{ 'TABLE.HEADER.DETAIL' | translate }}"></th>
              <th scope="col" [hidden]="hideDeleteItemOnlyRecord || allDocumentAreaUpload"
                  title="{{ 'TABLE.HEADER.ACTION' | translate }}">
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let document of documents; let index=index">
              <td title="#">{{ index + 1}}</td>
              <td title="{{ 'TABLE.HEADER.SUBJECT' | translate }}">
                {{document[0].subject}}
              </td>
              <td title="{{ 'TABLE.HEADER.PROGRESS' | translate }}">
                <div class="progress form-group mt-2 ">
                  <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                       [style.width.%]="getProgress(index)">
                  </div>
                </div>
              </td>
              <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
                {{document.status ? document.status : '-'}}
              </td>
              <td title="{{'TABLE.HEADER.DETAIL' | translate }}">
                {{document.detail ? document.detail : '-'}}
              </td>
              <td title="{{ 'TABLE.HEADER.ACTION' | translate }}" [hidden]="hideDeleteItemOnlyRecord || allDocumentAreaUpload">
                <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteRow(document)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isDataSource && hasFiles">
        <div class="modal-header div-custom">
          <h4
            class="modal-title fz-20">{{ "LABEL.DOCUMENT-LOADED" | translate }} {{getTotal()}}</h4>
        </div>
        <div class="row">
          <div class="col table-responsive">
            <table class="table-sm table-bordered">
              <thead class="thead-dark">
              <tr>
                <th scope="col" title="#"></th>
                <th scope="col" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"></th>
                <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
                <th scope="col" title="{{ 'TABLE.HEADER.DETAIL' | translate }}"></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let document of documents; let index=index">
                <td title="#">{{ index + 1}}</td>
                <td title="Asunto">{{document.documentNumber}}</td>
                <td title="Estado">{{getStatusUpload(document)}}</td>
                <td title="Detalle">{{getErrorDetailUpload(document)}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row justify-content-end">
        <div class="btn-padding-dlg" *ngIf="!isDataSource">
          <button type="button" class="btn btn-outline-success"
                  [disabled]="loading || allDocumentUpload"
                  (click)="save()">
            <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
          </button>
        </div>
        <div class="btn-padding-dlg">
          <button type="button" class="btn btn-outline-danger"
                  (click)="cancel()">
            <i class="fa fa-times-circle"></i> {{ "BUTTON.ACCEPT" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
